var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessagesFill = function SvgMessagesFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    d: "M24 4C12.972 4 4 11.178 4 20c0 5.816 3.796 11.03 10 13.868V44l10.68-8.01C35.394 35.704 44 28.64 44 20c0-8.822-8.972-16-20-16"
  })));
};
export { SvgMessagesFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDRDMTIuOTcyIDQgNCAxMS4xNzggNCAyMEM0IDI1LjgxNiA3Ljc5NiAzMS4wMyAxNCAzMy44NjhWNDRMMjQuNjggMzUuOTlDMzUuMzk0IDM1LjcwNCA0NCAyOC42NCA0NCAyMEM0NCAxMS4xNzggMzUuMDI4IDQgMjQgNFoiIGZpbGw9IiMyODNFNEMiLz4KPC9zdmc+Cg==";